import { Card, Center, Stack, Title } from "@mantine/core";
import { useEffect, useState } from "react";
import LoginForm from "../../components/auth/LoginForm/LoginForm";
import RegisterForm from "../../components/auth/RegisterForm/RegisterForm";
import NUSFinTechLabLogo from "../../images/NUS_finTech_Lab_Logo_1-removebg-preview.png";

import "./AuthPage.css";

const AuthPage = ({ initLoginMode }) => {
  const [isLoginMode, setIsLoginMode] = useState(initLoginMode);

  // /login and /register render the same AuthPage component — React Router
  // reuses the instance across the route change, so initial `useState`
  // never reruns. Sync the local mode with the prop so clicking the
  // top-right "Log In" link while on /register actually flips the form.
  useEffect(() => {
    setIsLoginMode(initLoginMode);
  }, [initLoginMode]);

  return (
    <div className="auth-page">
      <Center style={{ height: "100vh" }}>
        <Card
          withBorder
          p="xl"
          style={{ width: "90%", maxWidth: 600 }}
          shadow="xl"
        >
          <Stack p="xl">
            <img
              src={NUSFinTechLabLogo}
              alt="NUS FinTech Lab Logo"
              className="navbar__logo"
            />
            <Title align="center">
              Welcome to <span className="nus">NUS</span>
              <span className="wap">wap</span>
            </Title>
            {isLoginMode ? (
              <LoginForm setIsLoginMode={setIsLoginMode} />
            ) : (
              <RegisterForm setIsLoginMode={setIsLoginMode} />
            )}
          </Stack>
        </Card>
      </Center>
    </div>
  );
}
export default AuthPage;
